import { render, staticRenderFns } from "./ReCuratorContacts.vue?vue&type=template&id=f8c72a52&scoped=true"
import script from "./ReCuratorContacts.vue?vue&type=script&lang=js"
export * from "./ReCuratorContacts.vue?vue&type=script&lang=js"
import style0 from "./ReCuratorContacts.vue?vue&type=style&index=0&id=f8c72a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c72a52",
  null
  
)

export default component.exports